<script>
import {
  SubscriptionCardElementMixin,
} from "%/dynamic-component-editor/standard-components/subscription-card/subscription-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "SubscriptionPlanTitle",
  elementPanelSettings: {
    displayName: "Title",
    displayIcon: "text-alt",
    elementGroup: "subscriptionElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [SubscriptionCardElementMixin],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity.name;
    },
  },
};
</script>
